import { render, staticRenderFns } from "./WaBtn.vue?vue&type=template&id=b61b4bb2&scoped=true"
var script = {}
import style0 from "./WaBtn.vue?vue&type=style&index=0&id=b61b4bb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b61b4bb2",
  null
  
)

export default component.exports